export default __webpack_public_path__ + "static/media/closet5-before3-1440w.eba7e363.avif";